import Tiles from './components/Tiles';
import { Announcer } from './components/Announcer';
import { useInitAnnouncer } from './hooks/useInitAnnouncer';
import { Footer } from './components/Footer';
import { useAutoFontSize } from './hooks/useAutoFontSize';

export function Classic() {
    useInitAnnouncer();
    const { fontSize } = useAutoFontSize();

    return (
        <div className="flex flex-col justify-between flex-1">
            <div
                className="flex flex-1 flex-col"
                style={{
                    fontSize,
                }}
            >
                <Tiles />
                <Announcer />
                <Footer />
            </div>
        </div>
    );
}
